import { Directive, ElementRef, Input, OnChanges, Renderer2, Optional, Self } from '@angular/core';
import { Permission, Role, isAllowed } from './permissions';
import { MatSelect } from '@angular/material/select';

@Directive({ selector: '[appDisableByPermission]' })
export class DisableByPermissionDirective implements OnChanges {
  @Input('appDisableByPermission') permission!: Permission;
  @Input('appDisableByPermissionRole') role?: Role;

  constructor(
    private el: ElementRef<HTMLElement>, 
    private renderer: Renderer2,
    @Optional() @Self() private matSelect: MatSelect
  ) {}

  ngOnChanges(): void {
    const role = this.role ?? this.readRole();
    const allowed = isAllowed(role, this.permission);
    
    const element = this.el.nativeElement as any;
    
    // Handle mat-select specifically - use component instance
    if (this.matSelect) {
      this.matSelect.disabled = !allowed;
    } else {
      // Apply both disabled and readonly when permission is denied for regular elements
      this.renderer.setProperty(element, 'disabled', !allowed);
      
      // Also set readonly for input/textarea elements
      if (element.tagName === 'INPUT' || element.tagName === 'TEXTAREA') {
        this.renderer.setProperty(element, 'readOnly', !allowed);
      }
    }
    
    if (!allowed) this.renderer.addClass(this.el.nativeElement, 'is-disabled-permission');
    else this.renderer.removeClass(this.el.nativeElement, 'is-disabled-permission');
  }

  private readRole(): Role | null {
    try {
      const loginAs = localStorage.getItem('loginAs') || sessionStorage.getItem('loginAs');
      if (!loginAs) return null;
      return loginAs.trim() as Role;
    } catch { return null; }
  }
}


